import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  const handlePurchase = () => {
    window.location.href = 'https://checkout.recursostop.shop/cart/45775377465540:1';
  };
  return <section className="py-16 md:py-20 bg-gradient-to-b from-[#3D1F2E] to-[#2D1520] text-white relative overflow-hidden" data-id="element-149">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-150">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-purple-500 rounded-full blur-3xl" data-id="element-151"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-pink-400 rounded-full blur-3xl" data-id="element-152"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-153">
        <div className="text-center mb-8 md:mb-12" data-id="element-154">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 md:mb-6" data-id="element-155">
            📦 <span className="gold-title" data-id="element-156">Lo que recibís hoy</span>
          </h2>
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-sm md:text-lg text-gray-300 mb-6 md:mb-8" data-id="element-157">
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-158">
              ✔ 6 eBooks profesionales
            </span>
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-159">
              ✔ 3 bonos estratégicos
            </span>
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-160">
              ✔ Protocolos claros
            </span>
            <span className="bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full" data-id="element-161">
              ✔ Guías prácticas
            </span>
          </div>
          <p className="text-xl md:text-2xl font-bold text-purple-300" data-id="element-162">
            🎯 Total: 9 recursos completos
          </p>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden max-w-2xl mx-auto" data-id="element-163">
          <div className="bg-gradient-to-r from-[#C084FC] to-[#E879F9] text-white p-4 text-center font-bold uppercase tracking-widest text-sm" data-id="element-164">
            Oferta por tiempo limitado
          </div>
          <div className="p-6 md:p-12 text-center" data-id="element-165">
            <p className="text-gray-500 text-base md:text-lg mb-2" data-id="element-166">
              Precio regular:{' '}
              <span className="line-through decoration-purple-400 decoration-2" data-id="element-167">
                ARS $98.990
              </span>
            </p>
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-168">
              <span className="text-5xl md:text-7xl font-black text-gray-900 tracking-tighter" data-id="element-169">
                $19.990
              </span>
              <span className="text-lg md:text-xl font-bold text-gray-500 self-end mb-3 md:mb-4" data-id="element-170">
                ARS
              </span>
            </div>
            <p className="text-[#9333EA] font-bold bg-purple-50 inline-block px-4 py-1 rounded-full mb-6 md:mb-8 text-sm md:text-base" data-id="element-171">
              🔥 Ahorrás un 85% HOY
            </p>

            <Button onClick={handlePurchase} size="xl" fullWidth className="mb-6 text-lg md:text-2xl py-6 md:py-8" data-id="element-172">
              👉 OBTENER MI MEGAPACK AHORA
            </Button>

            <div className="flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-173">
              <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-174" />
              <span data-id="element-175">Pago 100% Seguro y Encriptado</span>
            </div>
            <div className="flex items-center justify-center gap-4 mt-4 opacity-70" data-id="element-176">
              <img src="https://cdn.magicpatterns.com/uploads/fL9kACheWktd2dhJwcnkzQ/mercado_pago.jpg" alt="Mercado Pago" className="h-8 rounded" data-id="element-177" />
            </div>
          </div>
          <div className="bg-purple-50 p-4 md:p-6 border-t border-purple-100" data-id="element-178">
            <div className="flex flex-col md:flex-row items-center gap-4 text-left" data-id="element-179">
              <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-180">
                <ShieldCheck className="w-8 h-8 text-green-600" data-id="element-181" />
              </div>
              <div data-id="element-182">
                <h4 className="font-bold text-gray-900" data-id="element-183">
                  Garantía sin riesgo de 7 días
                </h4>
                <p className="text-sm text-gray-600" data-id="element-184">
                  Si sentís que el material no te aporta claridad, estructura o
                  valor práctico, te devolvemos el 100% del dinero. Sin
                  preguntas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}